import type { UserWithMeta } from '~/@biz_account/useUser/types'

function getCompanyInfoItems(
  userProfile: UserWithMeta['profile'],
  country: string
) {
  return [
    { label: 'Názov firmy:', value: userProfile.company?.name },
    { label: 'IČO:', value: userProfile.company?.id },
    { label: 'DIČ:', value: userProfile.company?.vat },
    {
      label: 'IČ DPH:',
      value: userProfile.company?.vatNumber,
    },
    {
      label: 'Ulica a číslo:',
      value: userProfile.company?.streetAddress,
    },
    { label: 'Mesto:', value: userProfile.company?.city },
    { label: 'PSČ:', value: userProfile.company?.zipCode },
    { label: 'Krajina:', value: country },
  ]
}

export { getCompanyInfoItems }
